<abc-popup
  #popup
  fxLayout="column"
  fxLayoutAlign="center center"
  [width]="'40%'"
  [height]="'auto'"
  [title]="title"
  [showTitle]="true"
  [showCloseButton]="true"
  (onHidden)="handleSecondaryAction()"
>
  <div fxLayout="column" fxLayoutGap="15px">
    <span [innerHTML]="message"></span>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
      <abc-button
        class="submit-button"
        [text]="primaryBtnText"
        (onClick)="handlePrimaryAction()"
      ></abc-button>
      <abc-button
        class="cancel-button"
        [text]="secondaryBtnText"
        (onClick)="handleSecondaryAction()"
      ></abc-button>
    </div>
  </div>
</abc-popup>
